
<section class="testimonial-outer padding-lg">
    <div class="tabs-container">
        <div class="pane" id="tab1">
            <div class="col-lg-12 col-md-12">
                <div class="courses-details-desc">

                    <div style=" overflow: auto;">
                        <div class="row">
                            <ul class="nav-tabset">
                                <li class="nav-tab">

                                    <div class="searchBar">
                                        <input id="searchQueryInput" type="text" name="searchQueryInput"
                                            placeholder="Search" [(ngModel)]="serch" autocomplete="off"
                                            (keyup)="applyFilter($event)" />
                                        <button id="searchQuerySubmit" type="submit" name="searchQuerySubmit">
                                            <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                                <path fill="#fff"
                                                    d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
                                            </svg>
                                        </button>
                                    </div>


                                </li>
                                <!-- <li class="nav-tab">
                                            <div style="margin-bottom: 18px;">
                                                <ng-select placeholder="Select District">
                                                    <ng-option value="" selected disabled>Select District</ng-option>
                                                    <ng-option [value]="d.district_id"
                                                        *ngFor="let d of districtData">{{d.district_name}}</ng-option>
                                                </ng-select>
                                            </div>
                                        </li> -->

                                <li class="nav-tab" style="float: right;">
                                    <mat-paginator [pageSizeOptions]="[25,50,100]" showFirstLastButton></mat-paginator>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <table id="table-to-copied" #tab mat-table [dataSource]="dataSource" matSort
                                multiTemplateDataRows>
                                <ng-container matColumnDef="i">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="headerclass"> S.No
                                    </th>
                                    <td mat-cell *matCellDef="let row;let j = index" class="centre">
                                        <span class="para"> {{row.i}} </span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="district_name">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="headerclass">
                                        District Name
                                    </th>
                                    <td mat-cell *matCellDef="let row" style="white-space: nowrap;text-align: left;">

                                        <span class="para" style="text-align: left;"> {{row.district_name}}
                                        </span>

                                    </td>
                                </ng-container>
                                 <ng-container matColumnDef="mela_date">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="headerclass">
                                        Date
                                    </th>
                                    <td mat-cell *matCellDef="let row">
                                        <span class="para">
                                            {{row.mela_date | date:'dd-MM-yyyy'}} </span>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="mela_name">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="headerclass">
                                        Jobmela
                                    </th>
                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                        <span class="para"> {{row.mela_name}} </span>

                                    </td>
                                </ng-container>
                               
                                <ng-container matColumnDef="qualification">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="headerclass">
                                        Qualification
                                    </th>
                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                        <span class="para"> {{row.qualification}} </span>

                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="age_limit">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="headerclass">
                                        Age Limit
                                    </th>
                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                        <span class="para">
                                            {{row.age_limit? row.age_limit:'---'}}</span>

                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="salary">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="headerclass">
                                        Salary
                                    </th>
                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                        <span class="para"> {{row.salary?row.salary:'---'}} </span>

                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="work_location">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="headerclass">
                                        Work Location
                                    </th>
                                    <td mat-cell *matCellDef="let row" style="text-align: left;">
                                        <span class="para"> {{row.work_location?row.work_location:'---'}}
                                        </span>

                                    </td>
                                </ng-container>


                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="headerclass"
                                        style="width: 120px;">

                                    </th>
                                    <td mat-cell *matCellDef="let row" (click)="gotoviewDetails(row)">
                                        <span class="para" style="cursor: pointer;"><strong>View Details
                                            </strong></span>

                                    </td>
                                </ng-container>
                                <!-- Footer start -->
                                <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                                    class="example-element-row clickable-row">
                                </tr>
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" colspan="7" style="color: red;">No data found</td>
                                </tr>
                                <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
                                            class="example-detail-row"></tr> -->
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>